export const environment = {
    production: true,
    applicationUrl: 'votercircle.net',
};
